module.exports = __webpack_public_path__ + "img/swiper-banner14402.c7bca20b.webp";